export type ContentTypeName = 'translations' | 'templates' | 'pages' | 'CSS';

export type ContentData = {
  type: ContentTypeName;
  filename: string;
};

export type TranslationVersion =
  | 'frOrange'
  | 'v1'
  | 'enV2'
  | 'v2'
  | 'v3'
  | 'v4';

export const MajorTranslationVersion = [1, 2, 3, 4];

export const languages = ['de', 'en', 'fr', 'es', 'ca', 'it'] as const;
export const languagesAlphaVersion = ['de', 'en', 'fr', 'es'];
export const languagesBetaVersion = ['de', 'en', 'fr', 'es', 'it'];
export type LanguageCode = (typeof languages)[number];

export type Translation = ContentData & {
  type: 'translations';
  version?: TranslationVersion;
  language?: LanguageCode;
};

export type Template = ContentData & {
  type: 'templates';
  host: string;
};

export type Page = ContentData & {
  type: 'pages';
  version?: string;
  language?: LanguageCode;
};

export type CSSDictionary = ContentData & {
  type: 'CSS';
  host: string;
};

export type ContentType = Translation | Template | Page | CSSDictionary;

export type LogLevelType = 'silent' | 'error' | 'warn' | 'info' | 'verbose';

/* Created on purpose for future content expansion like below */
// type ContentType = Translation | 'other';
// ...
// type OtherContentData = ContentData & {
//   type: 'other';
//   test: 'otherContent';
// };
//
// .. (content: Translation | OtherContent) => { ..
